import {State} from "./SentMessagesDetails.types";
import {MagicReducerObject} from "@witivio_teamspro/use-reducer";
import {MenuProps} from "@fluentui/react-northstar";
import React from "react";
import {exportSendDraftNotificationSentDetails, resendNotificationToUnread} from "../../../apis/messageListApi";
import {FileModule} from "../../../modules/File.module";
import {IMessageState, ISentMessage} from "../../../Interfaces/Message";

export const initialState = (message: ISentMessage): State => ({
    menuIndex: 0,
    isExporting: false,
    isResending: message.state !== IMessageState.Sent,
    showSuccessTooltip: false,
});

export const reducer = {
    onChangeMenuIndex: ({setState}, [, data]: [React.SyntheticEvent, MenuProps | undefined]) => {
        const index = Number(data?.activeIndex ?? 0);
        setState({menuIndex: index});
    },
    exportData: async ({setState}, _, messageId: string | undefined) => {
        setState({isExporting: true});
        try {
            if (!messageId) return;
            const blob = await exportSendDraftNotificationSentDetails(messageId);
            FileModule.downloadFile(blob, "export.xlsx");
        } catch (error) {
            console.error(error);
        }
        setState({isExporting: false});
    },
    resendToUnread: async ({setState}, _, {messageId, onResendMessage}: {
        messageId: string | undefined,
        onResendMessage: (messageId: string) => void
    }) => {
        if (!messageId) return;
        setState({isResending: true});
        const isSuccess = await resendNotificationToUnread(messageId);
        setState({isResending: false, showSuccessTooltip: isSuccess});
        setTimeout(() => {
            setState({showSuccessTooltip: false});
        }, 3000);
        onResendMessage(messageId);
    }
} satisfies MagicReducerObject<State>;